import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Alert,
  CircularProgress,
  Grid
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import ProfileInformation from './ProfileInformation';
import ProfileSidebar from './ProfileSidebar';

import 'dayjs/locale/it';

const MemberProfile = () => {
  const { user, updateUser, loading: authLoading, error: authError } = useAuth();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [membership, setMembership] = useState(null);

  useEffect(() => {
    // Find the most recent membership by endDate
    if (user && Array.isArray(user.memberships) && user.memberships.length > 0) {
      const sorted = [...user.memberships].sort((a, b) => new Date(b.endDate) - new Date(a.endDate));
      setMembership(sorted[0]);
    } else {
      setMembership(null);
    }
  }, [user]);

  if (authLoading) {
    return (
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Alert severity="error">
            {authError || "Utente non autenticato. Effettua il login."}
          </Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>
          Profilo Utente
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <Grid container columns={12} columnSpacing={3}>
          {/* Profile Information */}
          <Grid size={{ xs: 12, md: 9 }} sx={{ order: { xs: 2, md: 1 } }}>
            <ProfileInformation 
              user={user}
              updateUser={updateUser}
              setError={setError}
              setSuccess={setSuccess}
            />
          </Grid>

          {/* Sidebar */}
          <Grid size={{ xs: 12, md: 3 }} sx={{ order: { xs: 1, md: 2 } }}>
            <ProfileSidebar 
              user={user}
              membership={membership}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default MemberProfile; 